import LanguageLocale from 'utils/LanguageLocale';

/**
 * Returns true when the AR change-quantity feature is enabled for the current country
 * (requires both the master flag and the per-country flag).
 *
 * @returns {boolean} Whether the change-quantity picker should be available.
 */
const isChangeQuantityEnabled = () => {
    const country = LanguageLocale.getCurrentCountry();
    const config =
        (typeof Sephora !== 'undefined' && Sephora.configurationSettings?.autoReplenishmentConfigurations?.changeQuantity) || {};

    return !!(config.isEnabled && config[`isEnabled${country}`]);
};

export { isChangeQuantityEnabled };
